import { defineAbility } from '@casl/ability'
import store from './store'

const user = store.state.user
const permissions = store.state.userPermissions
export default defineAbility((can) => {
  if (user.isAdmin) {
    can('create', 'all')
    can('read', 'all')
    can('update', 'all')
    can('delete', 'all')
  } else {
    for (let policy of permissions) {
      const fields = policy['policy'].split(':')
      const resource = fields[0].toLowerCase()
      const operation = fields[1].toLowerCase()
      can(operation, resource)
    }
  }
})
